// Copyright (c) 2023 Deere & Company

import {
    isNotEmpty,
    isNotNull
} from '../../../claim/shared/services/claim-shared-helper';
import actions from '../../actions-list';
import {containsPOBox} from '../services/validations';

const getAddress2 = ({dealer: {location: {address2 = ''} = {}} = {}} = {}) => address2;

const isAddress1Valid = (address1, duplicatePinPlate) =>
    isNotEmpty(address1) && !containsPOBox(address1) && !containsPOBox(getAddress2(duplicatePinPlate));

const mapFormValidation = (property, value, duplicatePinPlate) => {

    const map = {
        address1: line1 => isAddress1Valid(line1, duplicatePinPlate),
        city: isNotEmpty,
        country: isNotEmpty,
        dateSubmmited: isNotNull,
        dealer: isNotEmpty,
        factory: isNotEmpty,
        machineModel: isNotEmpty,
        mailingRecipient: isNotEmpty,
        missingPlateReason: isNotEmpty,
        phone: isNotEmpty,
        pin: isNotEmpty,
        requesterTCSM: isNotEmpty,
        shippingId: isNotEmpty,
        state: isNotEmpty,
        zipCode: isNotEmpty
    };

    return map[property](value, duplicatePinPlate);

};

export const updateFormValidation = (property, value, duplicatePinPlate) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_DUPLICATE_PIN_PLATE_FORM_VALIDATION,
            validity: mapFormValidation(property, value, duplicatePinPlate)
        });

export const resetFormValidation = () => ({
    type: actions.RESET_DUPLICATE_PIN_PLATE_FORM_VALIDATION
});



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/form-validation.js